export const NEW = 'NEW'
export const ACCEPTED = 'ACCEPTED'
export const REJECTED = 'REJECTED'
export const FINISHED = 'FINISHED'

export const requestStatusNames = {
  [NEW]: 'New',
  [ACCEPTED]: 'Confirmed',
  [REJECTED]: 'Declined',
  [FINISHED]: 'Closed',
}
